import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageMeta from '../hooks/usePageMeta';
import '../styles/static-pages.css';

function InformationalPage({ title, subtitle, content, seoTitle, seoDescription }) {
  usePageMeta({
    title: seoTitle || title,
    description: seoDescription || subtitle,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="static-page-root">
      <Header />
      <main className="static-page-main">
        <section className="static-page-hero">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </section>

        <section className="static-page-content">
          {content.map((paragraph, idx) => (
            <p key={`paragraph-${idx}`}>{paragraph}</p>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default InformationalPage;
